import { render } from "./DocumentReportOrigin.vue?vue&type=template&id=77498860&scoped=true&ts=true"
import script from "./DocumentReportOrigin.vue?vue&type=script&lang=ts"
export * from "./DocumentReportOrigin.vue?vue&type=script&lang=ts"

import "./DocumentReportOrigin.vue?vue&type=style&index=0&id=77498860&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77498860"]])

export default __exports__